import { render, staticRenderFns } from "./BranchBankAccounts.vue?vue&type=template&id=d1a01de2"
import script from "./BranchBankAccounts.vue?vue&type=script&lang=js"
export * from "./BranchBankAccounts.vue?vue&type=script&lang=js"
import style0 from "./BranchBankAccounts.vue?vue&type=style&index=0&id=d1a01de2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports